import(/* webpackMode: "eager", webpackExports: ["Providers"] */ "/app/packages/web/src/app/providers.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/packages/web/src/components/ui/SkipToMainContent.tsx");
;
import(/* webpackMode: "eager" */ "/app/packages/web/src/styles/globals.css");
